module.exports = __webpack_public_path__ + "static/media/background_grid_reverse.1373e80b.gif";